module.exports = __webpack_public_path__ + "img/47.b33c815e.jpg";